import { forwardRef } from 'react';

import { typography } from '../../../typography';
import { CheckIcon } from '../../icons';

import * as css from './ToggleSelectButton.css';

export type BasePopoverProps = Pick<React.HTMLAttributes<HTMLDivElement>, 'className'> & {
    handleSelectionChange: (val: string) => void;
    dropdownOptions: string[];
    checkIsActive: (val: string) => boolean;
    heading?: React.ReactNode;
};
export const BasePopover = forwardRef<HTMLDivElement, BasePopoverProps>(
    ({ heading, className, handleSelectionChange, dropdownOptions, checkIsActive }, ref) => {
        return (
            <div className={className}>
                {heading}
                <div className={css.popoverContent} ref={ref}>
                    {dropdownOptions.map((opt) => (
                        <div className={css.option} key={opt} onClick={() => handleSelectionChange(opt)}>
                            {checkIsActive(opt) && <CheckIcon size="1.5em" />}
                            <span className={typography({ variant: 'p' })}>{opt}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    },
);
